import * as Yup from 'yup';

const withoutReceiptSchema = [
  {
    name: 'pos_allow_return_receipt_cash',
    initialValue: '',
    input: {
      placeholder: 'Cash',
      className: 'pos_allow_return_receipt_cash',
      label: 'Cash',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_allow_return_receipt_cash_limit',
    initialValue: '',
    validation: Yup.number()
      .typeError('Limit must be a number')
      .positive('Limit be greater than zero'),
    input: {
      placeholder: 'Cash limit',
      className: 'pos_allow_return_receipt_cash_limit',
      type: 'input',
    },
  },
  {
    name: 'pos_allow_return_receipt_card',
    initialValue: '',
    input: {
      placeholder: 'Card',
      className: 'pos_allow_return_receipt_card',
      label: 'Card',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_allow_return_receipt_card_limit',
    initialValue: '',
    validation: Yup.number()
      .typeError('Limit must be a number')
      .positive('Limit be greater than zero'),
    input: {
      placeholder: 'Card limit',
      className: 'pos_allow_return_receipt_card_limit',
      type: 'input',
    },
  },
  {
    name: 'pos_allow_return_receipt_giftcard_serial',
    initialValue: '',
    input: {
      placeholder: 'Gift card (serial)',
      className: 'pos_allow_return_receipt_giftcard_serial',
      label: 'Gift card (serial)',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_allow_return_receipt_giftcard_serial_limit',
    initialValue: '',
    validation: Yup.number()
      .typeError('Limit must be a number')
      .positive('Limit be greater than zero'),
    input: {
      placeholder: 'Gift card (serial) limit',
      className: 'pos_allow_return_receipt_giftcard_serial_limit',
      type: 'input',
    },
  },
  {
    name: 'pos_allow_return_receipt_giftcard_regular',
    initialValue: '',
    input: {
      placeholder: 'Gift card (regular)',
      className: 'pos_allow_return_receipt_giftcard_regular',
      label: 'Gift card (regular)',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_allow_return_receipt_giftcard_regular_limit',
    initialValue: '',
    validation: Yup.number()
      .typeError('Limit must be a number')
      .positive('Limit be greater than zero'),
    input: {
      placeholder: 'Gift card (regular) limit',
      className: 'pos_allow_return_receipt_giftcard_regular_limit',
      type: 'input',
    },
  },
  {
    name: 'pos_allow_return_receipt_storecredit',
    initialValue: '',
    input: {
      placeholder: 'Store credit',
      className: 'pos_allow_return_receipt_storecredit',
      label: 'Store credit',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_allow_return_receipt_storecredit_limit',
    initialValue: '',
    validation: Yup.number()
      .typeError('Limit must be a number')
      .positive('Limit be greater than zero'),
    input: {
      placeholder: 'Store credit limit',
      className: 'pos_allow_return_receipt_storecredit_limit',
      type: 'input',
    },
  },
  {
    name: 'pos_allow_return_receipt_check',
    initialValue: '',
    input: {
      placeholder: 'Check',
      className: 'pos_allow_return_receipt_check',
      label: 'Check',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_allow_return_receipt_check_limit',
    initialValue: '',
    validation: Yup.number()
      .typeError('Limit must be a number')
      .positive('Limit be greater than zero'),
    input: {
      placeholder: 'Check limit',
      className: 'pos_allow_return_receipt_check_limit',
      type: 'input',
    },
  },
  {
    name: 'pos_allow_return_receipt_original_tender_only',
    initialValue: '',
    input: {
      placeholder: 'Allow receipt original tenders only',
      className: 'pos_allow_return_receipt_original_tender_only',
      label: 'Allow original tenders only',
      type: 'checkbox',
    },
  },
];

export default withoutReceiptSchema;
